import { InjectionToken } from '@angular/core';

export const SESSION_ID = new InjectionToken<string>('session-id');

export const STORAGE_USER_KEY = new InjectionToken<string>('storage-user-key');
